/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Cart drawer bridge for Finatics custom header.
// Warehouse's Cart class never initialises because it looks for .header__action-item--cart
// which the custom fnx- header doesn't have. This script replaces that behaviour:
// listen for product:added → refresh drawer → open; delegate cart-icon clicks to toggle.
(function () {
  'use strict';

  function init() {
    var miniCart = document.querySelector('.mini-cart');
    if (!miniCart) return;

    var isOpen = false;
    var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';

    function updateCount(n) {
      // Re-query each time: .fnx-cart-count is conditionally rendered when cart is empty
      var badge = document.querySelector('.fnx-cart-count');
      if (badge) badge.textContent = n;
    }

    function openDrawer() {
      miniCart.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-mobile-scroll');
      isOpen = true;
    }

    function closeDrawer() {
      miniCart.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-mobile-scroll');
      isOpen = false;
    }

    function refreshCart() {
      return fetch(cartUrl + '?section_id=mini-cart', {
        credentials: 'same-origin',
        headers: { 'Cache-Control': 'no-cache' }
      })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.mini-cart');
          if (fresh) {
            miniCart.innerHTML = fresh.innerHTML;
            updateCount(parseInt(fresh.getAttribute('data-item-count') || '0', 10));
          }
        });
    }

    // product:added → refresh drawer HTML then open
    document.addEventListener('product:added', function () {
      refreshCart().then(openDrawer);
    });

    // cart:refresh → refresh without auto-opening (quantity changes inside drawer)
    document.addEventListener('cart:refresh', function () {
      refreshCart();
    });

    // Cart icon toggle — event delegation so it fires regardless of which child element
    // (SVG path, circle, count badge) was the actual click target.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.fnx-cart-btn')) return;
      e.preventDefault();
      if (isOpen) {
        closeDrawer();
      } else {
        refreshCart().then(openDrawer);
      }
    });

    // Close on Escape
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    // Close on outside click — must be registered AFTER the toggle handler above
    // so the toggle fires first and isOpen is already updated when this runs.
    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (miniCart.contains(e.target)) return;
      if (e.target.closest('.fnx-cart-btn')) return;
      closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

/* Collection pagination: scroll to top of grid on page 2+ — URL polling, override-proof */
(function () {
  'use strict';
  function currentPage() {
    return new URLSearchParams(location.search).get('page') || '1';
  }
  function scrollToGrid() {
    if (parseInt(currentPage(), 10) <= 1) return;
    var tries = 0;
    (function attempt() {
      var el = document.getElementById('ProductGridTop');
      if (el) { el.scrollIntoView(); }
      else if (tries++ < 20) { setTimeout(attempt, 100); }
    })();
  }
  var lastPage = currentPage();
  // Poll the URL: fires on AJAX pagination regardless of which script owns history.pushState
  setInterval(function () {
    var p = currentPage();
    if (p !== lastPage) { lastPage = p; setTimeout(scrollToGrid, 300); }
  }, 150);
  // Also handle a direct load of a ?page=N URL
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToGrid);
  } else {
    scrollToGrid();
  }
}());


/* "Notify me when back in stock" — event delegation so it works for both
   the initial page render and the live section re-render on variant
   change (product-rerender swaps in fresh markup, so a per-element
   listener would be lost; delegation on document survives that). */
(function () {
  'use strict';

  var BAYOU_BASE = 'https://bayou-app-production.up.railway.app';
  var MERCHANT_DOMAIN = 'finatics-fishing.myshopify.com';

  // Not a real <form> — this snippet renders inside the theme's outer
  // <product-form>, and nested forms get silently stripped by the HTML
  // parser (which is exactly what ate the `hidden` attribute before this
  // fix). So: plain div, submit triggered by button click or Enter key.
  function submitNotifyMe(container) {
    var wrapper = container.closest('[data-notify-me]');
    var emailInput = container.querySelector('.notify-me__email');
    var submitBtn = container.querySelector('.notify-me__submit');
    var messageEl = container.querySelector('.notify-me__message');
    var email = (emailInput.value || '').trim();

    if (!email) { emailInput.reportValidity(); return; }

    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Submitting…';

    fetch(BAYOU_BASE + '/api/public/notify-me/' + MERCHANT_DOMAIN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: wrapper.getAttribute('data-product-id'),
        productHandle: wrapper.getAttribute('data-product-handle'),
        productTitle: wrapper.getAttribute('data-product-title'),
        variantId: wrapper.getAttribute('data-variant-id'),
        email: email,
      }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.error || 'Something went wrong.'); });
        return res.json();
      })
      .then(function () {
        container.querySelector('.notify-me__input-wrapper').hidden = true;
        messageEl.hidden = false;
        messageEl.style.color = '';
        messageEl.textContent = "We'll email you when this is back.";
      })
      .catch(function (err) {
        messageEl.hidden = false;
        messageEl.style.color = '#c0392b';
        messageEl.textContent = err.message || 'Something went wrong. Please try again.';
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.notify-me__toggle');
    if (toggle) {
      var wrapper = toggle.closest('[data-notify-me]');
      var form = wrapper.querySelector('.notify-me__form');
      toggle.hidden = true;
      form.hidden = false;
      var emailInput = form.querySelector('.notify-me__email');
      if (emailInput) emailInput.focus();
      return;
    }

    var submitBtn = e.target.closest('.notify-me__submit');
    if (submitBtn) {
      submitNotifyMe(submitBtn.closest('.notify-me__form'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var emailInput = e.target.closest('.notify-me__email');
    if (!emailInput) return;
    e.preventDefault();
    submitNotifyMe(emailInput.closest('.notify-me__form'));
  });
}());
